<script>
import Scrollbar from 'element-ui/lib/scrollbar';

export default Scrollbar;
</script>

<style lang="scss">
.el-scrollbar {
  &__wrap {
    @include rtl() {
      margin-left: -15px;
      margin-right: auto !important;
    }
  }
}
</style>
